import Avatar from './Avatar';
import Datepicker from './Datepicker';
import FormattedDateString from './FormattedDateString';
import InputFile from './InputFile';
import InputGroup from './InputGroup';
import InputHidden from './InputHidden';
import InputText from './InputText';
import MultiSelect from './MultiSelect';
import Pagination from './Pagination';
import PdfObject from './PdfObject';
import PhoneNumber from './PhoneNumber';
import TextArea from './TextArea';
import Select from './Select';
import Select2 from './Select2';
//import StarRating from './StarRating';
import Switch from './Switch';
import TimeAgo from './TimeAgo';

export {
        Avatar,
        CsrfToken,
        Datepicker,
        FormattedDateString,
        InputFile,
        InputGroup,
        InputHidden,
        InputText,
        MultiSelect,
        Pagination,
        PdfObject,
        PhoneNumber,
        Select,
        Select2,
        //StarRating,
        Switch,
        TextArea,
        TimeAgo
};




// WEBPACK FOOTER //
// ./resources/js/components/Core/index.js